import script from "./UserCenter.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserCenter.vue?vue&type=script&lang=ts&setup=true"

import "./UserCenter.vue?vue&type=style&index=0&id=467db78c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-467db78c"]])

export default __exports__